/* eslint-disable @typescript-eslint/naming-convention */
import {Injectable} from '@angular/core';
import {CoreCommands} from '@app/models/commands/core-commands';
import {WhiteboardCommands} from '@app/models/commands/whiteboard-commands';
import {AssignmentCommands} from '@app/models/commands/assignment-commands';
import {BlackboardCommands} from '@app/models/commands/blackboard-commands';
import {ChatCommands} from '@app/models/commands/chat-commands';
import {WRTCCommands} from '@app/models/commands/wrtc-commands';
import {PrivateWhiteboardCommands} from '@app/models/commands/private-whiteboard-commands';

export enum MsgRecordType {
  EVENT = 'EVENT',
  STATE = 'STATE'
}
export enum StateValue {
  ON = 'ON',
  OFF = 'OFF'
}

export class MessageRecord {
  category: string;
  type: MsgRecordType;
  ownerId: number;
  targetId?: number;
  name: string;
  data: string;
  timestamp?: number;
}

export interface ClassroomMessage {
  store: boolean;
  broadcast: boolean;
  selfProcess?: boolean;
  mirrorState?: string;
  record: MessageRecord;
}
export interface RecordStack {
  events: MessageRecord[];
  states: MessageRecord[];
}

export class RecordArgs {
  public data: string;
  public targetId?: number;

  constructor(data: string, targetId?: number) {
    this.data = data;
    this.targetId = targetId;
  }
}

@Injectable({
  providedIn: 'root'
})
export class DataService {

  public readonly MESSAGE_MAP = {
    ASSIGNMENT: this.assignmentCommands,
    WRTC: this.wrtcCommands,
    CORE: this.coreCommands,
    WHITEBOARD: this.whiteboardCommands,
    PRIVATE_WHITEBOARD: this.privateWhiteboardCommands,
    BLACKBOARD: this.blackboardCommands,
    CHAT: this.chatCommands
  };

  constructor(
    private coreCommands: CoreCommands,
    private whiteboardCommands: WhiteboardCommands,
    private privateWhiteboardCommands: PrivateWhiteboardCommands,
    private assignmentCommands: AssignmentCommands,
    private wrtcCommands: WRTCCommands,
    private blackboardCommands: BlackboardCommands,
    private chatCommands: ChatCommands
  ) {}

  /**
   * method calls handleMessage() method of record category
   *
   * @param message single message to handle
   * */
  public handleMessage(message: ClassroomMessage): void {
    this.MESSAGE_MAP[message.record.category].handleMessage(message);
  }
}
